import React, { useContext } from "react";
import { Col, Row } from "antd";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import styles from "src/styles";

// Contexts
import { OffsetLayoutContext } from "src/contexts/layout.context";

// Helpers
import { calculateLayout } from "src/helpers/ui.helper";

// Assets
import WhyUsImage from "src/assets/images/why_us.png";

const WhyUs = () => {
    const offsetLayout = useContext(OffsetLayoutContext);
    const layout = calculateLayout(offsetLayout, 24);

    return (
        <DivStyled className="why-us">
            <Row>
                <Col {...layout}>
                    <Row gutter={24}>
                        <Col
                            xs={{ span: 24 }}
                            lg={{ span: 12 }}
                            className="header"
                        >
                            <div className="title">
                                <FormattedMessage id="whyUs.title" />
                            </div>
                            <div className="content">
                                <div className="description">
                                    <FormattedMessage id="whyUs.description" />
                                </div>
                                <Row className="footer" gutter={12}>
                                    <Col xs={8} className="item">
                                        <Row>
                                            <Col span={24} className="value">
                                                440+
                                            </Col>
                                            <Col span={24} className="label">
                                                <FormattedMessage id="whyUs.corporateCustomer" />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={8} className="item">
                                        <Row>
                                            <Col span={24} className="value">
                                                86+
                                            </Col>
                                            <Col span={24} className="label">
                                                <FormattedMessage id="whyUs.governmentEntities" />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={8} className="item">
                                        <Row>
                                            <Col span={24} className="value">
                                                329+
                                            </Col>
                                            <Col span={24} className="label">
                                                <FormattedMessage id="whyUs.companies" />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col
                            xs={{ span: 24 }}
                            lg={{ span: 12 }}
                            className="images"
                        >
                            <img src={WhyUsImage} alt="" />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </DivStyled>
    );
};

const DivStyled = styled.div`
    &.why-us {
        color: ${styles.fontColorWhite};

        .header {
            padding: 12px 0;

            .title {
                margin-bottom: 34px;
                font-style: normal;
                font-weight: 500;
                font-size: 32px;
                line-height: 1.6;

                @media screen and (max-width: 767px) {
                    font-size: 24px;
                }
            }

            .content {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }

            .description {
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 1.6;

                @media screen and (max-width: 767px) {
                    font-size: 16px;
                }
            }

            .footer {
                display: flex;
                margin-top: 80px;

                @media screen and (max-width: 991px) {
                    margin-top: 30px;
                }

                & > .item {
                    .value {
                        font-style: normal;
                        font-weight: 700;
                        font-size: 30px;
                        line-height: 48px;

                        @media screen and (max-width: 767px) {
                            font-size: 24px;
                        }
                    }
                    .label {
                        font-style: normal;
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 26px;

                        @media screen and (max-width: 767px) {
                            font-size: 14px;
                        }
                    }
                }
            }
        }

        .images {
            @media screen and (max-width: 991px) {
                margin-top: 30px;
            }

            img {
                max-width: 100%;
            }
        }
    }
`;

export default WhyUs;
